<template>
  <div>
    <span
      class="pull-right customer-details-member"
      v-show="membershipStatus === 'active'"
      ><i
        class="text-primary fa fa-fw fa-3x fa-maxcdn"
        data-toggle="tooltip"
        data-placement="left"
        title="Aktives Mitglied"
      ></i
    ></span>
    <span
      class="pull-right customer-details-member"
      v-show="membershipStatus === 'inactive'"
      ><i
        class="text-warning fa fa-fw fa-3x fa-maxcdn"
        data-toggle="tooltip"
        data-placement="left"
        title="Inaktives Mitglied"
      ></i
    ></span>
    <span
      class="pull-right customer-details-member"
      v-show="membershipStatus === 'ex'"
      ><i
        class="text-light-grey fa fa-fw fa-3x fa-maxcdn"
        data-toggle="tooltip"
        data-placement="left"
        title="Ehemaliges Mitglied"
      ></i
    ></span>
  </div>
</template>

<script>
export default {
  props: {
    membershipStatus: {
      type: String,
      default: ""
    }
  }
};
</script>
